import { render, staticRenderFns } from "./QuickViewModal.vue?vue&type=template&id=74912619&"
import script from "./QuickViewModal.vue?vue&type=script&lang=ts&"
export * from "./QuickViewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports